import { useMemo } from 'react'
import Drawer from '../../../components/common/Drawer'
import Input from '../../../components/form/input/InputField'
import { useBusiness } from '../../../context/BusinessContext'
import { FilterType, useCommon } from '../../../context/CommonContext'
import { useProfessional } from '../../../context/ProfessionalContext'
import { useProduct } from '../../../context/ProductContext'
import { businessFilter } from '../../../functions/businessFilter'
import { extractCompanyOptions } from '../../../functions/businessOptions'
import Filter from './Filter'

const BusinessDrawerFilter = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const { business, setFilteredBusiness, setOpenFilter, filters, setFilters, clearFilters, searchIndex } =
        useBusiness()
    const { filtersOptions } = useCommon()
    const { professionals } = useProfessional()
    const { products } = useProduct()

    const formattedProfessionals = professionals.map(professional => ({
        id: Number(professional.id),
        label: String(professional.name)
    })) as FilterType[]

    const formattedProducts = products.map(product => ({
        id: Number(product.id),
        label: String(product.name)
    })) as FilterType[]

    //* Opções de empresas reais, derivadas dos negócios carregados
    const companyOptions = useMemo(() => extractCompanyOptions(business), [business])

    const handleFilter = () => {
        const filteredBusiness = businessFilter(business, filters, searchIndex)
        setFilteredBusiness(filteredBusiness)
        setOpenFilter(false)
    }

    if (!open) return null

    return (
        <Drawer
            open={open}
            handleClose={handleClose}
            title='Filtros'
            handleFilter={handleFilter}
            handleClean={clearFilters}
            maxWidth='max-w-2xl'
        >
            <div className='space-y-4'>
                <Input
                    type='text'
                    name='search'
                    placeholder='Pesquisar'
                    value={filters.search}
                    onChange={e => setFilters({ ...filters, search: e.target.value })}
                />
                <Filter title='Etiquetas' type='targets' selecteds={filters.targets} options={filtersOptions.targets} />
                <Filter title='Produtos' type='products' selecteds={filters.products} options={formattedProducts} />
                <Filter
                    title='Profissional'
                    type='creators'
                    selecteds={filters.creators}
                    options={formattedProfessionals}
                />
                <Filter title='Empresas' type='companies' selecteds={filters.companies} options={companyOptions} />
            </div>
        </Drawer>
    )
}

export default BusinessDrawerFilter
